import React, { useContext, useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { OrderDirection, SectionFilterResponse } from '../../Models/Models';
import { SiteContext } from '../../Contexts';
import { EntityColors } from '../../Themes/EntityColors';
import CustomTooltip from '../Tooltips/CustomTooltip';
import { Utils } from '../../Services/Utils';
import { SectionService } from '../../Services/SectionService';
import EditButton from '../Buttons/EditButton';
import TableShell from '../Table/TableShell';
import TableToolbar from '../Table/TableToolbar';

const SectionTableComponent = () => {
    useEffect(() => {
        Utils.setDocumentTitle('Sekcie');
    }, []);

    const { filterSections } = SectionService();
    const [response, setResponse] = useState<SectionFilterResponse | null>(null);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(6);
    const [orderDirection, setOrderDirection] = useState<OrderDirection>('Desc');
    const { currentSite }: any = useContext(SiteContext);
    const { action, icon } = EntityColors.page;
    const { pageId } = useParams<{ pageId: string }>();

    const loadPage = async (pageNum: number, opts?: { perPage?: number; order?: OrderDirection }) => {
        const limit = opts?.perPage ?? perPage;
        const resp = await filterSections({
            websiteId: currentSite.id,
            limit,
            offset: (pageNum - 1) * limit,
            pageId: Number(pageId),
            orderDirection: opts?.order ?? orderDirection,
        });
        setResponse(resp ?? null);
    };

    const changePerPage = (count: number) => {
        setPerPage(count);
        setPage(1);
        void loadPage(1, { perPage: count });
    };

    const changeOrder = (dir: OrderDirection) => {
        setOrderDirection(dir);
        setPage(1);
        void loadPage(1, { order: dir });
    };

    useEffect(() => {
        setPage(1);
        void loadPage(1);
    }, [currentSite]);

    return (
        <TableShell
            title="Sekcie"
            icon={icon}
            accentColor={action}
            backHref="/page/table"
            isLoading={response === null}
            isEmpty={response !== null && response.data.length === 0}
            emptyMessage="Žiadne sekcie"
            page={page}
            totalCount={response?.totalCount}
            perPage={perPage}
            onPageChange={p => { setPage(p); loadPage(p); }}
            toolbar={
                <TableToolbar
                    totalCount={response?.totalCount ?? 0}
                    nounForms={['sekcia', 'sekcie', 'sekcií']}
                    perPage={perPage}
                    onPerPageChange={changePerPage}
                    orderDirection={orderDirection}
                    onOrderChange={changeOrder}
                />
            }
        >
            <Table responsive>
                <thead>
                    <tr>
                        <th>Kód sekcie</th>
                        <th className="text-center">Akcie</th>
                    </tr>
                </thead>
                <tbody>
                    {response?.data.map(section => (
                        <tr key={section.id}>
                            <td className="st-cell-strong">{section.code}</td>
                            <td className="text-center">
                                <CustomTooltip placement="right" message="Upraviť">
                                    <Link to={`/section/edit/${section.id}`}>
                                        <EditButton color={action} iconOnly />
                                    </Link>
                                </CustomTooltip>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </TableShell>
    );
};

export default SectionTableComponent;
